<template>
    <div class="mt-1" >
        <h4 class="headline text-xs-center">Users</h4>
        <v-layout row>           
            <v-flex xs12 class="text-xs-right">
                <v-spacer></v-spacer>
                <v-btn to="/admin/userSignup" color="primary" large>Add New User</v-btn>
            </v-flex>
            <!-- <v-flex sm12 md6>
                <v-select
                label="Job Status"
                v-bind:items="statusList"
                v-model="searchCriteria.statusSelected"
                multiple
                hint=""
                persistent-hint
                ></v-select>
            </v-flex> -->
        </v-layout>
        <v-layout row v-if="error">
            <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-flex>
        </v-layout>  
        <v-card>
            <v-card-text>
                <h4>Filters</h4>
                <v-layout row  py-1>
                    <v-flex >
                        <v-text-field 
                            v-model="filterName" 
                            label="Name"
                            hint=""
                            ></v-text-field>
                    </v-flex>
                    <v-flex pl-1>
                        <v-select
                        v-model="filterRole"
                        :items="roles"
                        item-text='name'
                        item-value='id'
                        label="Roles"
                        ></v-select>
                    </v-flex>
                    <v-flex body-2 pl-2 pt-3>
                        <v-chip 
                            small
                            :color="filterShowActiveOnly?'green' : ''" 
                            @click="filterShowActiveOnly=!filterShowActiveOnly">
                            <v-avatar v-show="filterShowActiveOnly">
                                <v-icon>check_circle_outline</v-icon>
                            </v-avatar>
                            <v-avatar v-show="!filterShowActiveOnly">
                                <v-icon>radio_button_unchecked</v-icon>
                            </v-avatar>
                            Active Only
                        </v-chip>

                    </v-flex>
                        <v-btn color="secondary" @click="loadUsers">Submit</v-btn>
                    <v-flex>
                    </v-flex>

                </v-layout>
            </v-card-text>
            <v-card-text>
                <v-layout row>
                    <v-flex xs12>
                        <v-data-table
                            v-bind:headers="headers"
                            :items="users"
                            hide-actions
                            class="elevation-1"
                            >
                            <template slot="items" slot-scope="props">
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.source }}</td>
                            <td class="text-xs-left" :class="props.item.active === 'Active'?'green--text':'red--text'">{{ props.item.active }}</td>
                            <td class="text-xs-left">{{ props.item.roles }}</td>
                            <td class="text-xs-left">{{ props.item.lastLogin }}</td>
                            <td class="text-xs-left">{{ props.item.quoteCreatedCount }}</td>
                            <td class="text-xs-left error--text">
                                {{ props.item.userLocked? "User Account was locked after 5 times failed login. Please reset user password to unlock user." : "" }}</td>
                            <td class="text-xs-right">
                                <v-btn small @click.prevent="onActiveDeActiveUser(props.item.id)">{{ props.item.active == "Active" ? "Deactivate" : "Activate"}}</v-btn>
                                <br>
                                <v-btn small @click="editUser(props.item.id)">Edit</v-btn>
                            </td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>

            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    data: () => ({
        users: [],
        roles: [],
        filterName: null,
        filterShowActiveOnly: true,
        filterRole: 'All',
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'name'
          },
          { text: 'Import Source', align: 'left', value: 'source', sortable: true, },
          { text: 'Active', value: 'active' },
          { text: 'Roles', align: 'left', value: 'roles', sortable: true },
          { text: 'Last Login', align: 'left', sortable: true, value: 'lastLogin' },
          { text: 'Quote Created', align: 'left', value: 'quoteCreatedCount', sortable: true, },
          { text: 'Notes', align: 'left', sortable: false, },
          { text: '', align: 'left', sortable: false }
        ]
        // searchCriteria: {
        //     statusSelected: ['open', 'finished', 'cancelled']
        // },
        // statusList: ['open', 'finished', 'cancelled']
    }),
    computed: {
        userIsAuthenticated () {
            return this.$store.getters.userIsAuthenticated
        },
        user () {
            return this.$store.getters.user
        },
        error () {
            return this.$store.getters.error
        },
        loading () {
            return this.$store.getters.loading
        },
        
    },
    watch: {
        userIsAuthenticated (value) {
            if (!value) {
                this.$router.push('/')
            }
        }
    },
    methods: {
        ...mapActions('adminUser', [
            'searchUsers',
            'activeDeactiveUser',
            'getAllRoles'
        ]),

        editUser: function (id) {
            this.$router.push({ name: 'admin-user-edit', params: { id: id } })
        },
        async loadUsers () {
            const filter = {
                userRoles: this.filterRole == 'All'? null : [this.filterRole],
                isActive: this.filterShowActiveOnly,
                name: this.filterName,
                populateCreatedQuoteCount:true,
            }

            const result = await this.searchUsers(filter)
            if (typeof result === 'string') {
                alert(result)
            } else {
                this.users = result
            }
        },
        async onActiveDeActiveUser (id) {
            const result = await this.activeDeactiveUser(id)
            if (result === 'successful') {
                this.loadUsers()
            } else {
                alert(result)
            }
        },
        onDismissed () {
            // console.log('onDismissed alert')
            // this.$store.dispatch('clearError')
        }
    },
    created: async function () {
        // if (!this.$store.getters.userIsAuthenticated) {
        //     this.$router.push('/')
        // }
        this.roles = await this.getAllRoles()
        this.roles = ['All', ...this.roles]

        this.loadUsers()
    },
    destroyed: function () {
        this.onDismissed()
    }
}
</script>